import { IconSend } from '@tabler/icons-react';
import { useT } from '@hana/i18n';
import { useToast } from '@hana/ui';
import { CONFIRM_LABEL, confirmSub, debAction, type DebConfirm, type DebRow } from './deb';
import s from './ar.module.css';
import './debit.i18n';

// Mint-AR › tab "Theo debit / HĐ" (1536). TIỀN → chỉ khi có quyền `money`; chỉ đọc, nút ghi báo toast.
const KIND: Readonly<Record<string, string>> = { 'Debit': s.kPri ?? '', 'Hoá đơn': s.kCtl ?? '', 'Thuế NK nộp hộ': s.fWarn ?? '', 'Hoá đơn điều chỉnh': s.fErr ?? '' };
const CF: Readonly<Record<DebConfirm, string>> = { wait: s.fWarn ?? '', ok: s.fOk ?? '', auto: s.kCtl ?? '', tax: s.fWarn ?? '', paid: s.fOk ?? '' };
const nf = (x: number): string => x.toLocaleString('vi-VN', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
const HEAD: readonly (readonly [string, boolean])[] = [['db.hNo', false], ['db.hBill', false], ['db.hKind', false], ['db.hDate', false], ['db.hAmt', true], ['db.hLeft', true], ['db.hConf', false], ['db.hRem', false]];

export function DebitTable({ rows, money }: { rows: readonly DebRow[]; money: boolean }) {
  const t = useT();
  const toast = useToast();
  const m = (x: number) => (money ? nf(x) : '•••••');
  return (
    <section className={s.card} aria-label={t('db.aria')}>
      <table className={`${s.tbl} ${s.deb}`}>
        <thead>
          <tr>{HEAD.map(([l, right]) => <th key={l} className={right ? s.r : ''}>{t(l)}</th>)}<th /></tr>
        </thead>
        <tbody>
          {rows.map((d) => {
            const act = debAction(d);
            return (
              <tr key={d.no}>
                <td><b className={s.dno}>{d.no}</b><div className={`${s.sale} ${s.job}`}>{d.job}</div></td>
                <td><b className={s.dno2}>{d.bill}</b><div className={`${s.sale} ${s.job}`}>{d.billSub}</div></td>
                <td><span className={`${s.flag} ${KIND[d.kind] ?? ''}`}>{d.kind}</span></td>
                <td>{d.date}<div className={`${s.sale} ${d.overdue ? s.err : ''}`}>{d.due}</div></td>
                <td className={s.r}>{m(d.amt)}<div className={`${s.sale} ${s.rr}`}>VND</div></td>
                <td className={`${s.r} ${d.left > 0 ? '' : s.lb}`} style={{ fontWeight: 550 }}>{m(d.left)}</td>
                <td><span className={`${s.flag} ${CF[d.confirm]}`}>{CONFIRM_LABEL[d.confirm]}</span><div className={`${s.sale} ${s.job}`}>{confirmSub(d.confirm, d.days)}</div></td>
                <td className={s.tx2}>{d.rem}</td>
                <td className={s.r}>
                  {act && <button type="button" className={s.act} onClick={() => toast({ msg: t('db.noWrite') })}><IconSend size={16} aria-hidden="true" />{act}</button>}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </section>
  );
}
